/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CompanyMatchPagedData } from '../../models/company-match-paged-data';

export interface GetConfirmedCompanyMatches$Params {
  profileId: string;
  PageNumber?: number;
  PageSize?: number;
}

export function getConfirmedCompanyMatches(http: HttpClient, rootUrl: string, params: GetConfirmedCompanyMatches$Params, context?: HttpContext): Observable<StrictHttpResponse<CompanyMatchPagedData>> {
  const rb = new RequestBuilder(rootUrl, getConfirmedCompanyMatches.PATH, 'get');
  if (params) {
    rb.path('profileId', params.profileId, {});
    rb.query('PageNumber', params.PageNumber, {});
    rb.query('PageSize', params.PageSize, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CompanyMatchPagedData>;
    })
  );
}

getConfirmedCompanyMatches.PATH = '/studentprofile/{profileId}/match/company/confirmed';
